import React, { Component } from 'react';
import RequestUrl from '../commonjs/urlConfiger';
import HttpUtil from '../commonjs/httpUtil';
// import keyListener from '../commonjs/keyListener';
// import keyCodes from '../commonjs/keyCodes';
// import '../commonjs/fontPhoneSize';
// import $ from 'jquery';
// import Data from '../config/data';
import '../css/addr.css';
var TVBoxInfo = {};
function Base64() {

    // private property
    let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    // public method for encoding
    this.encode = function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = _utf8_encode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output +
            _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
    }

    // public method for decoding
    this.decode = function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
            enc1 = _keyStr.indexOf(input.charAt(i++));
            enc2 = _keyStr.indexOf(input.charAt(i++));
            enc3 = _keyStr.indexOf(input.charAt(i++));
            enc4 = _keyStr.indexOf(input.charAt(i++));
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }
        output = _utf8_decode(output);
        return output;
    }

    // private method for UTF-8 encoding
    const _utf8_encode = (string) => {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }
        return utftext;
    }

    // private method for UTF-8 decoding
    const _utf8_decode = (utftext) => {
        var string = "";
        var i = 0;
        var c1,c2,c3;
        var c = c1 = c2 = 0;
        while ( i < utftext.length ) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return string;
    }
}
export default class AddrDetail extends Component{
	constructor(props) {
        super(props);
        this.state = {
            addrData: [],
        };
	}
	componentDidMount(){
		var oBase64 = new Base64();
		TVBoxInfo.partnerCode = this.getUrlParam("partnerCode");
		TVBoxInfo.token = this.getUrlParam("token");
		TVBoxInfo.userid = this.getUrlParam("userId");
		TVBoxInfo.macCode = this.getUrlParam("mac");
		TVBoxInfo.deMacCode = TVBoxInfo.macCode;
		console.log(TVBoxInfo.macCode);
		let getAddrUrl = RequestUrl.getUserAddr(TVBoxInfo.partnerCode,TVBoxInfo.token,TVBoxInfo.userid,TVBoxInfo.deMacCode);
		this.getAddr(getAddrUrl);
	}
	getUrlParam = (name) => {
	    var regObj = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var matchResult = window.location.search.substr(1).match(regObj);
	    if (matchResult != null) {
	        return decodeURIComponent(matchResult[2]);
	    }
	    return null;
	}
	getAddr = (url) => {
		HttpUtil.getP(url).then((json) => {
			if(json.code === "A000000"){
				this.setState({
					addrData: json.data,
				})
			}
		},(json) => {
        	console.log("fail");
    	});
	}
	onPress = () => {
		this.props.history.replace({
            pathname: "/addr",
            search: "?type=750&partnerCode="+TVBoxInfo.partnerCode+"&userId="+TVBoxInfo.userid+"&mac="+TVBoxInfo.macCode+"&token="+TVBoxInfo.token,
        })
	}
	render(){
		let data = this.state.addrData;
		return (
			<div className="addrDetail">
				<div className="tips">
					<div>信息提交成功，客服人员</div>
					<div>将按照地址邮寄奖品</div>
				</div>
				<div className="addrMsg">
					<div className="clearfix">
						<span className="left">收货人：</span>
						<span className="left">{data.name}</span>
						<span className="right">{data.phoneNum}</span>
					</div>
					<div>
						<span>收货地址：</span>
						<span>{data.address}</span>
					</div>
					<a href="#" onClick={this.onPress}>修改&nbsp;&gt;</a>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/component/addrDetail.js